import React from 'react';
import { List, Datagrid, TextField, Edit, required, RichTextField,
     EditButton, SimpleForm, TextInput, Create, DeleteButton, CloneButton, Toolbar } from 'react-admin';

export const MenuItemList = props => (
    <List {...props}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="display_name" />
            <RichTextField  source="description" label={"Page Text"} />
            <TextField source="video_link" />
            <EditButton />
            <DeleteButton mutationMode={"pessimistic"} />
            <CloneButton />
        </Datagrid>
    </List>
);

export const MenuItemEdit = props => (
    <Edit title={<MenuItemTitle />} {...props}>
        <SimpleForm toolbar={<Toolbar alwaysEnableSaveButton={true}/>}>
            <TextInput source="id" disabled />
            <TextInput source="name" resettable validate={required()}/>
            <TextInput source="display_name" label={"Display Name"} resettable validate={required()}/>
            <TextInput multiline style={{direction: "rtl"}} source="description" label={"Page Text"} resettable validate={required()}/>
            <TextInput source="video_link" />
        </SimpleForm>
    </Edit>
);

export const MenuItemCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name" resettable validate={required()}/>
            <TextInput source="display_name" label={"Display Name"} resettable validate={required()}/>
            <TextInput multiline style={{direction: "rtl"}} source="description" label={"Page Text"} resettable validate={required()}/>
            <TextInput source="video_link" />
        </SimpleForm>
    </Create>
);

const MenuItemTitle = ({ record }) => {
    return <span>MenuItem {record ? `"${record.display_name}"` : ''}</span>;
};